import { FormGroup } from "../../../components/form";
import * as yup from "yup";

export const transferRequestForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      fieldType: "textarea",
      key: "transferDetail",
      label: "Transfer Request Details",
      validation: yup.string().trim().required("A response is required"),
      warn: "Record any relevant information regarding the transfer request",
    },
    {
      type: "field",
      key: "internalNotes",
      fieldType: "textarea",
      label: "Internal notes",
      props: {
        rows: 5,
        col: 30,
        autoResize: true,
      },
    },
    {
      type: "field",
      key: "advisory2",
      fieldType: "advisory",
      props: {
        type: "warning ",
      },
      label:
        "When you save your request, this application will become read-only and a new transfer application will be created. All relevant information will be copied from this application to the transfer application. The kindergarten user for the kindergarten to which the child is transferring will then need to complete the relevant sections of the application before submitting it for review and assessment.",
    },
    {
      type: "field",
      key: "transferApplicationId",
      fieldType: "button",
      label: "Open Transfer Application",
      props: {
        className: "form-button",
        disabled: false,
      },
      expressionProps: {
        onClick: (context) => () => window.open(`/applications/ApplicationBaseCurrent/${context.nextApplicationId}`, "_blank"),
      },
      hideExpression: (context) => !context.hasTransfer,
    },
  ],
};
